export default "__VITE_ASSET__CUXDtdYH__"